import React from 'react';
import PropTypes from 'prop-types';
import ListIcon from '@learningblocks/exp-constants/lib/Icons/alert-large-success';
import parse from 'html-react-parser';
import './style.scss';

export function SummaryList(props) {
  const renderListItem = (summaryItem, key) => (
    <li key={key} className='summaryList__listblock_item'>
      <ListIcon className='summaryList__listblock_item_icon' />
      <p className='summaryList__listblock_item_text'>{parse(summaryItem)}</p>
    </li>
  );

  return (
    <div className='summaryList'>
      <div className='summaryList__titleblock'>
        <h4 className='summaryList__titleblock_title'>{props.heading}</h4>
      </div>
      <ul className='summaryList__listblock'>
        {props.items.map(renderListItem)}
      </ul>
    </div>
  );
}

SummaryList.propTypes = {
  /**
   * Title of the list
   */
  title: PropTypes.string,
  /**
   * List of summary Items
   */
  list: PropTypes.arrayOf(PropTypes.string),
};
